import { gql } from '@apollo/client';
import BusinessNetworkFieldsFragment from "../../../fragments/BusinessNetworkFields";

const LIST_BUSINESS_NETWORKS = gql`
  query ListBusinessNetworks($companyId: Int!) {
    companyAdminContext {
      companyNetworks {
        listCompanyNetworks(companyId: $companyId) {
          parentNetworks {
            ...CompanyNetworkFields
          }
          networks {
            ...CompanyNetworkFields
          }
        }
      }
    }
  }

  ${BusinessNetworkFieldsFragment}
`;

export default LIST_BUSINESS_NETWORKS;
